<template>
  <v-data-table
    :headers="headers"
    :items="orderLists"
    :items-per-page="5"
    class="elevation-1"
    @click:row="tableRowClick(orderLists.id)"
  ></v-data-table>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: '상품 명',
          align: 'start',
          value: 'name'
        },
        { text: '수량', value: 'quantity' },
        { text: '구매 금액', value: 'price' },
        { text: '구매 날짜', value: 'date' }
      ],
      orderLists: []
    }
  },

  created () {
    console.log('created')
    this.subscribe()
  },

  updated () {
    console.log('updated')
  },

  destroyed () {
    console.log('destroyed')
    if (this.unsubscribe) this.unsubscribe()
  },

  mounted () {
    console.log('mounted')
  },

  filters: {
    currency (value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },

  methods: {
    subscribe () {
      var _this = this

      var userID = _this.$firebase.auth().currentUser.uid

      _this.unsubscribe = _this.$firebase.firestore().collection('orders').where('userID', '==', userID).onSnapshot((sn) => {
        if (sn.empty) {
          _this.orderLists = []
          return
        }

        _this.orderLists = sn.docs.map(v => {
          const orders = v.data()

          return {
            id: v.id,
            name: orders.productTitle,
            quantity: orders.Quantity,
            price: String(orders.paymentPrice).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 원',
            date: orders.orderDate
          }
        })
      })
    },

    tableRowClick (id) {
      console.log(id)
    }
  }
}
</script>
